import { createFileRoute } from '@tanstack/react-router';
import { EmployeeForm } from '@/features/employees/components/employee-form';

export const Route = createFileRoute('/_authenticated/employees/$id/edit')({
  component: EditEmployeeRoute,
});

function EditEmployeeRoute() {
  const { id } = Route.useParams();
  
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Edit Employee</h1>
      <EmployeeForm employeeId={id} />
    </div>
  );
} 